/**
 * @generated SignedSource<<f5f948216491f5af5a64fc8873ec1336>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getAppliedFilterDisplayName_itemSearch$data = {
  readonly appliedFilters: ReadonlyArray<{
    readonly name: string | null;
    readonly values: ReadonlyArray<{
      readonly displayName: string | null;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "getAppliedFilterDisplayName_itemSearch";
};
export type getAppliedFilterDisplayName_itemSearch$key = {
  readonly " $data"?: getAppliedFilterDisplayName_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"getAppliedFilterDisplayName_itemSearch">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getAppliedFilterDisplayName_itemSearch"
};

(node as any).hash = "348471a2cb4c0bf215fc40f5948a0c3b";

export default node;
